import React, { useEffect, useState } from 'react';
const BUYERS = [{
  name: 'María José',
  city: 'Buenos Aires'
}, {
  name: 'Luciana',
  city: 'Córdoba'
}, {
  name: 'Valeria',
  city: 'Rosario'
}, {
  name: 'Florencia',
  city: 'Mendoza'
}, {
  name: 'Carolina',
  city: 'La Plata'
}, {
  name: 'Daniela',
  city: 'Tucumán'
}, {
  name: 'Romina',
  city: 'Mar del Plata'
}, {
  name: 'Natalia',
  city: 'Salta'
}, {
  name: 'Silvina',
  city: 'San Juan'
}, {
  name: 'Graciela',
  city: 'Neuquén'
}, {
  name: 'Patricia',
  city: 'Bahía Blanca'
}, {
  name: 'Claudia',
  city: 'Resistencia'
}, {
  name: 'Verónica',
  city: 'Posadas'
}, {
  name: 'Marcela',
  city: 'Santa Fe'
}, {
  name: 'Adriana',
  city: 'San Luis'
}];
export function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const [toastVisible, setToastVisible] = useState(false);
  const [toastData, setToastData] = useState(BUYERS[0]);
  const [toastIndex, setToastIndex] = useState(0);
  useEffect(() => {
    // Show first toast after 3s, then every 8s
    const show = () => {
      const next = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setToastData(next);
      setToastVisible(true);
      setTimeout(() => setToastVisible(false), 4000);
    };
    const initial = setTimeout(show, 3000);
    const interval = setInterval(show, 9000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);
  return <section id="inicio" className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" aria-label="Sección principal" data-id="element-39">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/no2x6Xyss8b8YKBa71vjS3/ChatGPT_Image_28_feb_2026,_05_15_48_p.m..png')`
    }} aria-hidden="true" data-id="element-40" />
      {/* Dark navy overlay */}
      <div className="absolute inset-0" style={{
      backgroundColor: 'rgba(13, 27, 46, 0.82)'
    }} aria-hidden="true" data-id="element-41" />

      {/* Live purchase toast */}
      <div aria-live="polite" className="fixed bottom-6 left-4 z-50 transition-all duration-500" style={{
      transform: toastVisible ? 'translateY(0)' : 'translateY(120%)',
      opacity: toastVisible ? 1 : 0
    }} data-id="element-42">
        <div className="flex items-center gap-3 bg-white rounded-2xl shadow-2xl px-4 py-3 max-w-xs border border-gray-100" data-id="element-43">
          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 text-lg" data-id="element-44">
            🛒
          </div>
          <div data-id="element-45">
            <p className="text-navy-deep font-bold text-sm leading-tight" data-id="element-46">
              {toastData.name} acaba de comprar
            </p>
            <p className="text-gray-500 text-xs" data-id="element-47">
              📍 {toastData.city}, Argentina
            </p>
          </div>
          <div className="w-2 h-2 rounded-full bg-green-400 flex-shrink-0 animate-pulse" data-id="element-48" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 flex flex-col items-center text-center" data-id="element-49">
        {/* Top Badge */}
        <div className="mb-6" data-id="element-50">
          <span className="inline-block bg-gold text-navy-deep text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full" style={{
          letterSpacing: '0.12em'
        }} data-id="element-51">
            EL RECURSO #1 PARA DOCENTES DE CATEQUESIS EN ARGENTINA 🇦🇷
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-52">
          Mega Pack Catequesis Lista:
          <br data-id="element-53" />
          <span className="text-gold" data-id="element-54">Herramientas Completas</span>
        </h1>

        {/* Product Mockup with bounce */}
        <div className="my-4 w-full max-w-xs mx-auto" style={{
        animation: 'gentleBounce 3s ease-in-out infinite'
      }} data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/duRKPLUByYSy6rXFPwEp6j/ChatGPT_Image_27_feb_2026,_02_26_12_p.m.-Photoroom.png" alt="Mega Pack Catequesis Lista - 12 tomos PDF completos" className="w-full h-auto drop-shadow-2xl" style={{
          maxHeight: '260px',
          objectFit: 'contain'
        }} data-id="element-56" />
        </div>

        {/* Subtitle */}
        <p className="text-white text-sm sm:text-base max-w-xl mx-auto mb-8 leading-relaxed opacity-90" data-id="element-57">
          Planificaciones, actividades y proyectos listos para usar en el aula o
          en catequesis parroquial.{' '}
          <strong className="text-gold" data-id="element-58">
            Transformá tus clases de religión desde mañana.
          </strong>
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-59">
          <button onClick={() => scrollTo('precios')} className="bg-gold text-navy-deep font-bold text-lg px-10 py-4 rounded-full hover:bg-gold-light transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-60">
            Adquirir Ahora
          </button>
          <button onClick={() => scrollTo('incluye')} className="border-2 border-white text-white font-semibold text-lg px-10 py-4 rounded-full hover:bg-white hover:text-navy-deep transition-all duration-200" data-id="element-61">
            Más Información
          </button>
        </div>

        {/* Trust indicators */}
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-white opacity-75 text-sm" data-id="element-62">
          <span data-id="element-63">✓ Acceso inmediato</span>
          <span data-id="element-64">✓ Garantía 7 días</span>
          <span data-id="element-65">✓ Pago seguro 🔒</span>
        </div>
      </div>

      <style data-id="element-66">{`
        @keyframes gentleBounce {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </section>;
}